export default function ScanIcon({ className }: any) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M21 10L21 9C21 8.07003 21 7.60504 20.8978 7.22354C20.6204 6.18827 19.8117 5.37962 18.7765 5.10222C18.395 5 17.93 5 17 5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M3 10L3 9C3 8.07003 3 7.60504 3.10222 7.22354C3.37962 6.18827 4.18827 5.37962 5.22354 5.10222C5.60504 5 6.07003 5 7 5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M21 14L21 15C21 15.93 21 16.395 20.8978 16.7765C20.6204 17.8117 19.8117 18.6204 18.7765 18.8978C18.395 19 17.93 19 17 19"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M3 14L3 15C3 15.93 3 16.395 3.10222 16.7765C3.37962 17.8117 4.18827 18.6204 5.22354 18.8978C5.60504 19 6.07003 19 7 19"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M12 15L12 9" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 14L8 10" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 14L16 10" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
